module.exports = __webpack_public_path__ + "img/allow-up.b44991a1.svg";